const triggerDownload = (url: string, filename?: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || '';
  link.target = '_blank';
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const backendUrl = (url: string) => `${process.env.GPEXE_BACKEND_URL}${url.slice(1)}`;

export const openZipUrl = (url: string) => {
  const storedOnS3 = url.slice(0, 5) === 'https';
  triggerDownload(storedOnS3 ? url : backendUrl(url));
};

export const downloadFile = (url: string, storedOnS3: boolean, filename?: string) => {
  triggerDownload(storedOnS3 ? url : backendUrl(url), filename);
};
